<template>
    <div id="emails">
        <v-dialog v-model="showDialog" max-width="500">
            <v-card>
            <v-card-title class="headline">{{msg}}</v-card-title>
            <!-- <v-card-text>
                Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.
            </v-card-text> -->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo white--text" depressed @click="showDialog = false">Ok</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="indigo spacyEmails" height="30px" id="emails__header">
            
            <div id="emails__header--1" ><b class="bold_font">ID</b></div>
            

          
            <div id="emails__header--3" ><b class="bold_font">Subject</b></div>
            <div id="emails__header--4" ><b class="bold_font">Sender Email</b></div>
            <div id="emails__header--5" ><b class="bold_font">Date</b></div>
            
            <div id="emails__header--6" ><b class="bold_font">Action</b></div>
            
        </div>
        <div v-if="isloading" class="loader"></div>
        <v-card v-else-if="emails.length > 0">
            <v-list id="emails__list">
                <v-list-item-group>
                    <SpaceyEmailsItem v-for="(email,i) in emails" 
                        v-bind:key="email.id"
                        v-bind:email="email"
                        :class="emailClass(i)"
                        ref="email"
                    />
                </v-list-item-group>
            </v-list>
        </v-card>
        <div v-else>No Records</div>
       
    </div>
</template>
<script>
    import _ from 'lodash'
    import SpaceyEmailsItem from './../components/SpaceyEmailsItem'
    
    export default {
        name: 'Emails',
        data() {
            return {
                orders: [
                    {'key': 'muid', 'val': true},
                    {'key': 'email_subject', 'val': true},
                    {'key': 'email_from', 'val': true},
                    {'key': 'panelist_core', 'val': true},
                    {'key': 'point', 'val': true},
                    {'key': 'email_date', 'val': true},
                    {'key': 'panelist_score', 'val': true},
                    {'key': 'email_read', 'val': true},
                ],
                enableSorting: false,
                showDialog: false,
                msg: '',
            }
        },
        components: {
            SpaceyEmailsItem,
        },
        mounted() {
            let nodes = document.querySelectorAll(".v-messages"), size = nodes.length, i = 0
            for (i = 0; i < size; i++) {
                nodes[i].style.display = 'none'
            }
            this.$refs.boxcheck.firstChild.style.marginTop = '3px'
            if (!this.$store.getters['Search/getIsFromSearch']) {
                this.$utils.fetchEmails(this)
            }
            nodes = document.querySelectorAll(".v-text-field__details"), size = nodes.length
            for (i = 0; i < size; i++) {
                nodes[i].style.display = "none"
            }
        },
        computed: {
            emails: function () {
                return this.allEmails()
            },
            isloading: function () {
                return this.$store.getters['Emails/getIsLoading']
            },
            selectall: {
                get: function() {
                    return this.$store.getters['Emails/getAllChecked']
                },
                set: function(v) {
                    var view = this
                    view.$store.dispatch('Emails/setUpdateAll', v).then(function() {
                        view.$refs.email.forEach(function(o) {
                            o.checkThisEmail(v)
                        })
                    })
                }
            },
            product_id: {
                get: function() {
                    return this.$store.getters['Emails/getProductId']
                },
                set: function(n) {
                    var view = this,
                        o = view.$store.getters['Emails/getProductId'],
                        c = n.split(o).pop(),
                        regex = /[\d -]+/g
                    if (!regex.test(c)) {
                        view.$store.dispatch('Emails/setProductId', '').then(function() {
                            view.showDialog = true
                            view.msg = 'Please enter only numeric value or hyphon.'
                            return
                        })
                    } else {
                        this.$store.dispatch('Emails/setProductId', n)
                    }
                }
            }
        },
        methods: {
            getPages: function () {
                var arr = new Array(),
                    start = parseInt(1),
                    end = parseInt(this.lastPage), i;
                if (parseInt(this.totPage) > parseInt(10)) {
                    if (parseInt(this.currentPage) <= 4) {
                        end = 9
                    } else if (parseInt(this.currentPage) == parseInt(this.lastPage)) {
                        start = parseInt(this.lastPage / 10) * 10 + 1
                        end = this.lastPage
                    } else if (parseInt(this.currentPage) >= parseInt(5)) {
                        start = this.currentPage - 4
                        if (parseInt(this.lastPage) - parseInt(this.currentPage) <= 4) {
                            end = this.lastPage
                        } else {
                            end = this.currentPage + 4
                        }
                    }
                }
                for (i = start; i <= end; i++) {
                    arr.push(i)
                }
                return arr
            },
            sortBy: function (sortby) {
                this.enableSorting = true
                const order = _.find(this.orders, function (o) {
                    return o.key === sortby;
                });
                var view = this,
                    payload = this.$store.getters['Emails/getResponsePayload'],
                    sorted = _.sortBy(payload, [function (o) {
                        return order.key === 'muid' ? parseInt(o[order.key]) : o[order.key];
                    }]);
                view.$store.dispatch('Emails/setResponsePayload', order.val ? sorted : sorted.reverse()).then(function () {
                    view.orders.forEach(function (o) {
                        if (o.key === order.key) {
                            o.val = !o.val;
                        }
                    });
                }).catch(function (e) {
                    console.log(e)
                })
            },
            allEmails: function() {
                if (this.enableSorting) {
                    this.enableSorting = false
                    return this.$store.getters['Emails/getResponsePayload']
                } else {
                    // if (this.$store.getters['Search/getIsFromSearch']) {
                    //     return this.$store.getters['Emails/getResponsePayload']
                    // } else {
                    //     return _.sortBy(this.$store.getters['Emails/getResponsePayload'], [function(o) {
                    //         return parseInt(o.muid)
                    //     }])
                    // }
                    return this.$store.getters['Emails/getResponsePayload']
                }
            },
            emailClass: function(i) {
                return parseInt(i)%2 === parseInt(0) ? 'grey lighten-2' : 'grey lighten-5'
            },
            assignEmails: function() {
                var view = this,
                    objs = view.$store.getters['Emails/getUpdateObjects'],
                    prod_id = view.$store.getters['Emails/getProductId'],
                    v = view.$utils.validate(this),
                    myPromise = new Promise(function(resolve, reject) {
                        if (prod_id.length === 0) {
                            view.showDialog = true
                            view.msg = 'Product ID can not be empty.'
                            reject('Product ID can not be empty.')
                        } else {
                            resolve(true)
                        }
                    })
                myPromise.then(function() {
                    return new Promise(function(resolve, reject) {
                        if (objs.length === 0) {
                            view.showDialog = true
                            view.msg = 'Please choose atleast one record.'
                            reject('Please choose atleast one record.')
                        } else {
                            resolve(true)
                        }
                    })
                }).then(function() {
                    return new Promise(function(resolve, reject) {
                        if (v !== true) {
                            view.showDialog = true
                            view.msg = v
                            reject(v)
                        } else {
                            resolve(true)
                        }
                    })
                }).then(function() {
                    view.$fetch({
                        url: view.$url('ASSIGN_COPY'),
                        type: 'POST',
                        data: JSON.stringify({
                            payload: objs,
                            entryID: view.$store.getters['Emails/getProductId']
                        }),
                        contentType: "application/json"
                    },{
                operation: 'add',
                vueScope: view
            }).then(function(response) {
                        view.showDialog = true
                        view.msg = response.msg
                    })
                }).catch(e => console.log(e))
            }
        },
    }
</script>
<style lang="sass" scoped>
    @import "./../assets/sass/spacey.sass"
</style>
